// extracted by mini-css-extract-plugin
module.exports = {"text":"Feedbackform_text__JxHD9"};